import React from "react";
import { useTranslation } from "react-i18next";
import type { ModalProps } from "antd/lib";
import { ModalWrapper } from "../ModalWrapper";

interface Props extends ModalProps {
  modalTitle: string;
}

export const ModalDeleteContent: React.FC<Props> = ({ modalTitle, ...props }) => {
  const { t } = useTranslation();
  return (
    <ModalWrapper type="delete" modalTitle={modalTitle} {...props}>
      <div>{t("common.delete")}</div>
    </ModalWrapper>
  );
};
